export default "__VITE_ASSET__DPO60ZCC__"